import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import ModalEditarApontamentoParada from "components/modal/meta/producao/ModalEditarApontamentoParada";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Usuario from "model/administracao/cadastro/Usuario";
import ApontamentoMotivoParada from "model/meta/producao/ApontamentoMotivoParada";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import ApontamentoMotivoParadaService from "service/meta/producao/ApontamentoMotivoParadaService";
import { converterDataHora, converterHorario } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate } from "utils/filterUtils";

const apontamentoMotivoParadaService = new ApontamentoMotivoParadaService();

export default function ApontamentoMotivoParadaListagem() {

    const titulo = 'Apontamentos de Parada';
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [operacoes, setOperacoes] = useState<OperacaoProducao[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);

    const listagemRef = useRef<BaseListagemRef>(null);

    const [modalEdicao, setModalEdicao] = useState<{ visible: boolean, apontamento: ApontamentoMotivoParada | null }>({ visible: false, apontamento: null });

    useEffect(() => {
        apontamentoMotivoParadaService.produtos().then((response) => {
            setProdutos(response);
        }).catch((err) => {
            console.error(err);
        });
        apontamentoMotivoParadaService.clientes().then((response) => {
            setClientes(response);
        }).catch((err) => {
            console.error(err);
        });
        apontamentoMotivoParadaService.operacoes().then((response) => {
            setOperacoes(response);
        }).catch((err) => {
            console.error(err);
        });
        apontamentoMotivoParadaService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((err) => {
            console.error(err);
        });

    }, []);

    const defaultFilters: DataTableFilterMeta = {
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        operacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        usuario: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        data: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const abrirModalEdicao = (rowData: ApontamentoMotivoParada) => {
        setModalEdicao({ visible: true, apontamento: rowData });
    }

    return (
        <>
            {modalEdicao.visible ? <ModalEditarApontamentoParada
                value={modalEdicao.apontamento!}
                visible={modalEdicao.visible}
                onHide={() => setModalEdicao({ visible: false, apontamento: null })}
                onConfirm={() => {
                    listagemRef.current?.reload();
                    setModalEdicao({ visible: false, apontamento: null })
                }}
            /> : null}
            <BaseListagem ref={listagemRef} ordenacao="dataApontamento,DESC" service={apontamentoMotivoParadaService} urlService="/apontamentoMotivoParada" tituloPagina={titulo}
                defaultFilters={defaultFilters}
                showClearFilterButton nome="apontamentoMotivoParada"
                showNewButton={false} showEditButton={false} >

                <Column field="metaProducaoOperacao.metaProducao.produto.nome" header="Produto" filterField="produto" filter showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />}
                    filterApply={filterApplyTemplate} />
                <Column field="metaProducaoOperacao.metaProducao.cliente.nome" header="Cliente" filter filterField="cliente" showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, clientes)} />
                <Column field="metaProducaoOperacao.operacao.descricao" header="Operação" filter filterField="operacao" showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, operacoes, "descricao")} />
                <Column field="usuario.nome" header="Usuário" filter filterField="usuario" showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, usuarios)} />
                <Column field="dataApontamento" header="Data"
                    body={(rowData) => converterDataHora(rowData.dataApontamento)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="data"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="descricao" header="Motivo"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column field="inicioParada" header="Início da parada" body={(rowData) => rowData.inicioParada != null ? converterHorario(rowData.inicioParada) : ""} />
                <Column field="fimParada" header="Fim da parada" body={(rowData) => rowData.fimParada != null ? converterHorario(rowData.fimParada) : ""} />
                <Column body={(rowData) => <Button icon="pi pi-pencil" onClick={() => abrirModalEdicao(rowData)} />} />
            </BaseListagem>
        </>
    )
}